import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/clientHttp/http.service';
import { Request } from 'src/app/core/clientHttp/request';
// import { FeedbacksModel } from 'src/app/modules/client/feedbacks/services/feedbacks.model';


@Injectable({
  providedIn: 'root'
})
export class FeedbackService extends Request {

  private response: any = null;
  public callback;
  public callbackError;
  public data;

  constructor(
    private http: HttpService
  ) {
    super();
    this.data = {};
  }

  getData(id, callback, callbackError) {
    this.callback = callback;
    this.callbackError = callbackError;
    this.data.token = localStorage.getItem('token');
    this.url = 'applyment/feedback/' + id;
    this.http.get(this);
  }

  successAction(res) {
    if (res.success) {
      this.callback(res.data);
    } else {
      this.callback(false);
    }
  }

  errorAction(error) {
    this.callbackError(error);
  }
}
